import { render } from "./PostBlock.vue?vue&type=template&id=a31b8c00&scoped=true"
import script from "./PostBlock.vue?vue&type=script&lang=js"
export * from "./PostBlock.vue?vue&type=script&lang=js"

import "./PostBlock.vue?vue&type=style&index=0&id=a31b8c00&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31b8c00"]])

export default __exports__